
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 8h24v8H0V8z","fill":"#fff","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M19.352 2.505a1 1 0 01.898.995v1.25h2c.406 0 .798.141 1.11.396l.127.117.117.128c.255.311.396.703.396 1.109V8a4 4 0 01-3.802 3.995L20 12h-.185c-.949 2.732-3.36 4.797-6.315 5.183V19h2a1 1 0 110 2h-6a1 1 0 110-2h2v-1.817a7.754 7.754 0 01-1.925-.506A7.751 7.751 0 015.166 12H5a4 4 0 01-3.995-3.802L1 8V6.5c0-.464.185-.91.513-1.237l.128-.117A1.75 1.75 0 012.75 4.75h2V3.5l.005-.103A1 1 0 015.75 2.5h13.5l.102.005zM6.75 9.5l.007.284c.014.278.048.553.101.825.044.104.07.217.077.335a5.735 5.735 0 003.395 3.881 5.75 5.75 0 002.214.425l.294-.01c2.544-.15 4.642-1.989 5.24-4.412a5.888 5.888 0 00.172-1.412V4.5H6.75v5zm13.5-.084c0 .191-.01.381-.023.57A1.999 1.999 0 0022 8V6.75h-1.75v2.666zM3 6.75V8l.01.197a2 2 0 001.757 1.787c-.003-.033-.006-.067-.007-.101L4.75 9.5V6.75H3z","fill":"#FDFDFD"}})])
          )
        }
      }
    